import 'react-native-gesture-handler';

// Some internal React-Native libraries are using removeListener and that shows a warning every time the app runs.
import { LogBox } from 'react-native';
LogBox.ignoreLogs(['EventEmitter.removeListener']);

import React, { useEffect, useState } from 'react';
import { Platform, StatusBar, StyleSheet } from 'react-native';
import { setResponseInterceptors } from './src/apiCalls/customAxios';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import * as SplashScreen from 'expo-splash-screen';
import { SafeAreaProvider, initialWindowMetrics, SafeAreaView } from 'react-native-safe-area-context';
import { AppContextProvider } from './src/context/ContextProviders';
import RootNavigation from './src/navigations/RootNavigator';
import { COLORS } from './src/constants/colors';
import { isMobile, isMobileApp } from '@/utils/general/device-info';
import { MB_PopUp } from '@/components/general/pop-up';
import { MB_Toast } from '@/components/general/toast';
import { useAppInitialSetup } from './src/hooks/useAppInitialSetup';
import { CustomToastConfig } from './src/components/helperComponents/CustomToastConfig';

// Response interceptors for axios. By default it is used to intercept certain errors and handle them in a special way.
setResponseInterceptors();

if (Platform.OS === 'android' || Platform.OS === 'ios') {
  SplashScreen.preventAutoHideAsync().catch(warning => console.log('Warning. Failed to prevent splash screen auto hide ', warning));
}

const App = () => {
  const [isAppReady, setIsAppReady] = useState(false);
  const isInitialSetupComplete = useAppInitialSetup();
  // isAppReady is intended to be set by rootNavigator when all necessary data has been pulled from the server

  useEffect(() => {
    if (isMobileApp && isAppReady && isInitialSetupComplete) {
      SplashScreen.hideAsync().catch(error => console.error('Error when hiding splash screen', error));
    }
  }, [isInitialSetupComplete, isAppReady]);

  if (!isInitialSetupComplete) {
    return null;
  }

  return (
    <SafeAreaProvider initialMetrics={initialWindowMetrics}>
      {isMobile && <StatusBar barStyle={'light-content'} />}

      <SafeAreaView style={styles.safeAreaView}>
        <AppContextProvider>
          <RootNavigation onReady={setIsAppReady} />

          <MB_PopUp />

          {process.env.NODE_ENV === 'development' && Platform.OS === 'web' && <ReactQueryDevtools initialIsOpen={false} position="bottom-right" />}

          <MB_Toast config={CustomToastConfig} absolutePositionForWeb />
        </AppContextProvider>
      </SafeAreaView>
    </SafeAreaProvider>
  );
};

export default App;

const styles = StyleSheet.create({
  safeAreaView: {
    flex: 1,
    backgroundColor: COLORS.darkBackground,
  },
});
